import * as React from "react";
import { Viewport, ViewSmall, ViewMedium } from "bernie-view";
import { UitkSpacing } from "uitk-react-spacing";
import { withStores } from "stores";
import { TripsImportant } from "@shared-ui/trips-lists";
import { Experiment as Experiments, isVariantEnabled } from "src/components/utility/experiment";
import { TripsBexApiComponentProps } from "components/shared/BexApiWrapper/TripsBexApiWrapper";

export const TripsOverviewImportant = withStores("cookies")(
  ({ inputs: { flexContext }, cookies }: TripsBexApiComponentProps) => {
    const { PWA_Trips_Important_SF } = Experiments;

    const isTripsEnabled = () => {
      try {
        return Number(cookies.getCookie("trips-sdui-enabled")) === 1;
      } catch (e) {
        return false;
      }
    };

    const isTripsExperimentEnabled = isVariantEnabled(flexContext, PWA_Trips_Important_SF) && isTripsEnabled();

    if (!isTripsExperimentEnabled) {
      return null;
    }

    return (
      <div className="TripsOverviewImportant" data-testid="trips-overview-important">
        <Viewport>
          <ViewSmall>
            <UitkSpacing padding={{ block: "three" }}>
              <div>
                <TripsImportant />
              </div>
            </UitkSpacing>
          </ViewSmall>
          <ViewMedium />
        </Viewport>
      </div>
    );
  }
);

export default TripsOverviewImportant;
